import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
// React Router
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import App from "./App";

//Custom CSS
import "./App.css";

// Redux
import { Provider } from "react-redux";
import { store } from "./redux/store";

// Pages
import Home from "./pages/Home/HomePage";
import AboutUs from "./pages/About/AboutUsPage";
import FounderPage from "./pages/About/FounderPage";
import ContactUs from "./pages/ContactUs/ContactUsPage";
import GetQuote from "./pages/GetQuote/GetQuotePage";
import MyQuotes from "./pages/GetQuote/MyQuotes";
import BomOrderPage from "./pages/BomOrder/BomOrderPage";
import FpcStackupPage from "./pages/PcbPrototype/FpcStackupPage";
import RequestQuote from "./pages/RequestQuote/RequestQuotePage";
import OdmServices from "./pages/OdmServices/OdmServicesPage";
import ProductsPage from "./pages/Products/ProductsPage";
import ProductComparePage from "./pages/Products/ProductComparePage";
import ProductDetails from "./pages/Product-details/ProductDetailsPage";
import NotFound from "./pages/NotFoundPage";
import ProtectedRoute from "./components/ProtectedRoute";

// Auth Pages
import Login from "./pages/Auth/LoginPage";
import Register from "./pages/Auth/RegisterPage";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";

// Cart
import Cart from "./pages/Cart/CartPage";
import Shipping from "./pages/Shipping/Shipping";
import PaymentMethod from "./pages/Payment/PaymentMethod";

// User Pages
import Profile from "./pages/User/MyProfile/Profile";
import Updateprofile from "./pages/User/UpdateProfile";
import UploadAvatar from "./pages/User/UploadAvatar";
import UpdatePassword from "./pages/User/UpdatePassword";

//Privacy Policy
import PrivacyPolicy from "./pages/Policy/PrivacyPolicy";
import TermsAndConditions from "./pages/Policy/TermsConditions";
import FaqPage from "./pages/Policy/FaqPage";

 //PayPal Script
import { PayPalScriptProvider } from '@paypal/react-paypal-js';

import { HelmetProvider } from "react-helmet-async";

// CategoryDetails
import CategoryDetails from "./pages/Category/CategoryDetailsPage";
 
// Orders
import MyOrders from "./pages/Order/MyOrders";
import OrderDetails from "./pages/Order/OrderDetails";
import Invoice from "./components/invoice/Invoice";
import PlaceOrder from "./pages/Order/ConfirmOrder";
import OrderSuccess from "./pages/Order/OrderSuccess";

// 在线工具使用路由级懒加载，避免增加站点首页主包体积。
const Resources = lazy(() => import("./pages/Resources"));
const ResourcesDetails = lazy(
  () => import("./pages/Resources/ResourcesDetails")
);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index={true} path="/" element={<Home />} />
      <Route path="/about_us" element={<AboutUs />} />
      <Route path="/our_founder" element={<FounderPage />} />
      <Route path="/contact_us" element={<ContactUs />} />
      <Route path="/get_quote" element={<GetQuote />} />
      <Route path="/bom-order" element={<BomOrderPage />} />
      <Route path="/bom-order/:bomId" element={<BomOrderPage />} />
      <Route path="/pcb_prototype/Stack_up_for_FPC.html" element={<FpcStackupPage />} />
      <Route path="/request_quote" element={<RequestQuote />} />
      <Route path="/odm_services" element={<OdmServices />} />
      <Route path="/privacy_policy" element={<PrivacyPolicy />} />
      <Route path="/terms_conditions" element={<TermsAndConditions />} />
      <Route path="/faq" element={<FaqPage />} />

      <Route path="/products" element={<ProductsPage />} />
      <Route path="/products/compare" element={<ProductComparePage />} />
      <Route path="/products/:id" element={<ProductDetails />} />

      <Route path="/category/:id" element={<CategoryDetails />} />

      <Route
        path="/calculators"
        element={
          <Suspense fallback={<div className="p-4 text-center">Loading...</div>}>
            <Resources />
          </Suspense>
        }
      />
      <Route
        path="/calculators/:slug"
        element={
          <Suspense fallback={<div className="p-4 text-center">Loading...</div>}>
            <ResourcesDetails />
          </Suspense>
        }
      />

      <Route path="/cart" element={<Cart />} />

      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Register />} />
      <Route path="/forgot_password" element={<ForgotPassword />} />
      <Route path="/password/reset/:token" element={<ResetPassword />} />

      <Route
        path="/order_success"
        element={
          <ProtectedRoute>
            <OrderSuccess />
          </ProtectedRoute>
        }
      />

      <Route
        path="/confirm_order"
        element={
          <ProtectedRoute>
            <PlaceOrder />
          </ProtectedRoute>
        }
      />

      <Route
        path="/invoice/order/:id"
        element={
          <ProtectedRoute>
            <Invoice />
          </ProtectedRoute>
        }
      />

      <Route
        path="/me/orders"
        element={
          <ProtectedRoute>
            <MyOrders />
          </ProtectedRoute>
        }
      />

      <Route
        path="/me/quotes"
        element={
          <ProtectedRoute>
            <MyQuotes />
          </ProtectedRoute>
        }
      />

      <Route
        path="/me/order/:id"
        element={
          <ProtectedRoute>
            <OrderDetails />
          </ProtectedRoute>
        }
      />

      <Route
        path="/payment_method"
        element={
          <ProtectedRoute>
            <PaymentMethod />
          </ProtectedRoute>
        }
      />

      <Route
        path="/shipping"
        element={
          <ProtectedRoute>
            <Shipping />
          </ProtectedRoute>
        }
      />

      <Route
        path="/me/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/me/update_profile"
        element={
          <ProtectedRoute>
            <Updateprofile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/me/upload_avatar"
        element={
          <ProtectedRoute>
            <UploadAvatar />
          </ProtectedRoute>
        }
      />
      <Route
        path="/me/update_password"
        element={
          <ProtectedRoute>
            <UpdatePassword />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <PayPalScriptProvider deferLoading={true}>
          <RouterProvider router={router} />
        </PayPalScriptProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);
